import URLS from "@api/constants/urls";
import {
  handleGlobalDeleteRequest,
  handleGlobalPostRequest,
  handleGlobalPatchRequest,
} from "@api/functions/changeRequests";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { URLSearchParamsInit } from "react-router-dom";
import {
  IInsurersResponseSchema,
  IInsurersSubmitSchema,
} from "./insurersAPI.types";
import { IGlobalMetaSchema } from "@api/types/globalService.types";

const getAllInsurersAPI = ({
  searchParams,
  signal,
}: {
  searchParams?: URLSearchParamsInit;
  signal?: AbortSignal;
}): Promise<{ data: IInsurersResponseSchema[]; meta: IGlobalMetaSchema }> =>
  handleGlobalGetRequestQuery({ url: URLS.INSURERS, searchParams, signal });

const getSingleInsurersAPI = (
  id: string
): Promise<{ data: IInsurersResponseSchema }> =>
  handleGlobalGetRequestQuery({
    url: `${URLS.INSURERS}/${id}`,
  });

const createInsurersAPI = (
  data: IInsurersSubmitSchema
): Promise<{ data: IInsurersResponseSchema }> =>
  handleGlobalPostRequest({ url: URLS.INSURERS, data });

const updateInsurersAPI = (
  data: IInsurersSubmitSchema
): Promise<{ data: IInsurersResponseSchema }> =>
  handleGlobalPatchRequest({ url: `${URLS.INSURERS}/${data.id}`, data });

const deleteInsurersAPI = (id: number) =>
  handleGlobalDeleteRequest({ url: `${URLS.INSURERS}/${id}` });

export {
  getAllInsurersAPI,
  getSingleInsurersAPI,
  createInsurersAPI,
  updateInsurersAPI,
  deleteInsurersAPI,
};
